import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/empty';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/switchMap';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import type { Extension } from '../../model/extension/types.tsx';
import { transformExtensionLoad } from '../../services/extension/index.tsx';
import { loadExtensionDataService } from '../../services/load-extension-data/index.tsx';
import { makeServiceContext } from '../../services/service-context/index.tsx';
import { SET_APP_DATA } from '../../state/actions/app/index.tsx';
import { extensionFetchSuccess } from '../../state/actions/extension/index.tsx';
import type { Action, ActionsObservable, MiddlewareAPI } from '../../state/types.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (action$: ActionsObservable, store: MiddlewareAPI): Observable<Action> =>
	action$.ofType(SET_APP_DATA).switchMap(() => {
		const state = store.getState();
		const ctx = makeServiceContext(state);

		return loadExtensionDataService(ctx)
			.map(transformExtensionLoad)
			.flatMap((extension: Extension) => Observable.of(extensionFetchSuccess(extension)))
			.catch((error: Error) => {
				log.safeErrorWithoutCustomerData('backlog.extension.operations', error.message, error);
				// ABE-21: Handle this when the call is made as part of the non-critical path
				return Observable.empty<never>();
			});
	});
